import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtAuthInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Retrieve the token from local storage (or wherever you store the JWT)
    const token: string = localStorage.getItem('api-key-token');

    // Check if the token is present
    if (token != null && token.length > 0) {
      // Clone the request and replace the original headers with
      // cloned headers, updated with the authorization.
      const authReq = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + token),
      });

      // send cloned request with header to the next handler.
      return next.handle(authReq);
    }

    // If the token is not present, just pass the request as it is to the next handler
    return next.handle(req);
  }
}
